module.exports = __webpack_public_path__ + "static/media/eye-open.f2102e10.svg";